// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.slide-enter-active[data-v-3dcd6605], .slide-leave-active[data-v-3dcd6605] {\r\n  transition: all 0.3s ease;\n}\n.slide-enter-from[data-v-3dcd6605], .slide-leave-to[data-v-3dcd6605] {\r\n  transform: translateX(100%);\r\n  opacity: 0;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
